import { useSelector } from 'react-redux';

/**
 *
 * @returns {string} Project uuid
 */
export function useActiveProject() {
  return useSelector((state) => state.organizationsProjects.selectedProjectUuid);
}
